class CartFooterAddon extends HTMLElement {
  constructor() {
    super();

    this.variantId = JSON.parse(this.querySelector('#cart-addon-variant').textContent);
    this.checkbox = this.querySelector('[data-cart-addon-checkbox]');

    this.checkbox.addEventListener('change', (e) => {
      this.updateCart(e.target.checked);
    });

    document.addEventListener('theme:cart:change', (event) => {
      const cart = event.detail.cart;
      const inCart = this.isVariantInCart(cart.items);
      this.checkbox.checked = inCart;
    });
  }

  isVariantInCart(items) {
    return items.some((item) => item.variant_id === this.variantId);
  }

  updateCart(checked) {
    const updates = {};
    updates[this.variantId] = checked ? 1 : 0;

    window
      .fetch(`${window.theme.routes.cart}/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates }),
      })
      .then((response) => response.json())
      .then((response) => {
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: response }, bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      });
  }
}

customElements.define('cart-footer-addon', CartFooterAddon);
